import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { accessor } from '../../helpers';
import { EmptyPage } from '../EmptyPage';

const ProfileTable = ({users, type, profileName}) => {
    const captionEnum = {
        total: {label: 'общая', key: 'totalStats'},
        profile: {label: 'профильная', key: 'isProfileStats'},
        notProfile: {label: 'непрофильная', key: 'isNotProfileStats'},
    }
    const caption = `${profileName} (${captionEnum[type].label} статистика)`;
    const profType = captionEnum[type].key;

    const totalAverage = Math.round(
        users.reduce((total, cur) => total + cur.stats[profType].turnover, 0) / 
        users.reduce((total, cur) => total + cur.stats[profType].ordersCount, 0)
    ).toLocaleString('fr-FR') || 0;

    
    const sortedList = [...users].sort((u1, u2) => u2.stats[profType].averageCheque - u1.stats[profType].averageCheque);

    const totalOrdersCount = users.reduce((total, cur) => total + cur.stats[profType].ordersCount, 0);
    const totalWarrantyCount = users.reduce((total, cur) => total + cur.stats[profType].warrantyCount, 0);
    const totalTurnover = users.reduce((total, cur) => total + cur.stats[profType].turnover, 0).toLocaleString('fr-FR') || 0;
    return (
        <div className='profile-table-container'>
            <div className="profile-table__caption">{caption}</div>
            <div className="profile-table dark-theme-bg0">
                <div className="profile-table__header">
                    <div className='profile-table__worker'>Мастер</div>
                    <div className='profile-table__average'>Средний</div>
                    <div className='profile-table__o-count'>Заказов</div>
                    <div className='profile-table__w-count'>Гарантий</div>
                    <div className='profile-table__turnover'>Вал</div>
                </div>
                <div className="profile-table__body">
                    {sortedList.map((user) => (
                        <div className="profile-table__row" key={user.fullname}>
                            <div className='profile-table__worker'>{user.fullname}</div>
                            <div className='profile-table__average'>
                                {user.stats[profType].averageCheque.toLocaleString('fr-FR') || 0}
                            </div>
                            <div className='profile-table__o-count'>{user.stats[profType].ordersCount || 0}</div>
                            <div className='profile-table__w-count'>{user.stats[profType].warrantyCount || 0}</div>
                            <div className='profile-table__turnover'>
                                {user.stats[profType].turnover.toLocaleString('fr-FR') || 0}
                            </div>
                        </div>
                    ))}
                    <div className="profile-table__row total">
                            <div className='profile-table__worker'>Общая</div>
                            <div className='profile-table__average'>{totalAverage}</div>
                            <div className='profile-table__o-count'>{totalOrdersCount}</div>
                            <div className='profile-table__w-count'>{totalWarrantyCount}</div>
                            <div className='profile-table__turnover'>{totalTurnover}</div>
                        </div>
                </div>
            </div>
        </div>
    )
}

const ProfileTables = ({users, profileType}) => {
    const thisProfileUsers = users.filter((u) => u.stats.find((st) => st.profileType._id === profileType._id))
    .map((u) => ({...u, stats: u.stats.find((st) => st.profileType._id === profileType._id)}));
    const usersWithNotProfileStats = thisProfileUsers.map((u) => {
        const {totalStats, isProfileStats} = u.stats;
        const isNotProfileStats = {};
        for (const key in totalStats) {
            isNotProfileStats[key] = totalStats[key] - isProfileStats[key];
        }
        isNotProfileStats.averageCheque = Math.round(isNotProfileStats.turnover/isNotProfileStats.ordersCount) || 0
        return {...u, stats: {...u.stats, isNotProfileStats}};
    })
    const totalProfUsers = usersWithNotProfileStats.filter((u) => u.stats.totalStats.ordersCount)
    const onlyProfUsers = usersWithNotProfileStats.filter((u) => u.stats.isProfileStats.ordersCount)
    const onlyNotProfUsers = usersWithNotProfileStats.filter((u) => u.stats.isNotProfileStats.ordersCount)

    const hasData = totalProfUsers.length || onlyProfUsers.length || onlyNotProfUsers.length;
    const columnsCount = Number(!!totalProfUsers.length) + Number(!!onlyProfUsers.length) + Number(!!onlyNotProfUsers.length);
    return ( hasData ?
        <div className="profile-tables" style={{gridTemplateColumns: `repeat(${columnsCount}, 1fr)`}}>
            {!!totalProfUsers.length && <ProfileTable users={totalProfUsers} type="total"  profileName={profileType.name} />}
            {!!onlyProfUsers.length && <ProfileTable users={onlyProfUsers} type="profile"  profileName={profileType.name} />}
            {!!onlyNotProfUsers.length && <ProfileTable users={onlyNotProfUsers} type="notProfile"  profileName={profileType.name} />}
        </div> : null
    )
}
export const StatsPage = () => {
    const users = useSelector((state) => state.users.list);
    const usersWithStats = users.filter((u) => u.stats);
    const userCities = useSelector((state) => state.settings.userCities);
    const userProfiles = useSelector((state) => state.settings.userProfiles);
    const months = useSelector((state) => state.orders.months);
    const userInfo = useSelector((state) => state.auth);

    const [month, setMonth] = useState(+localStorage.getItem('userStatsMonth') || months[months.length - 1].timestamp);
    const [city, setCity] = useState(userCities[0]?._id || 'null');

    const thisMonthUsers = usersWithStats.map((u) => ({ fullname: u.fullname, stats: u.stats }))
        .filter((u) => u.stats.some((st) => st.monthTimestamp === month))
        .map((u) => ({ ...u, stats: u.stats.find((m) => m.monthTimestamp === month)}));

    const thisCityUsers = thisMonthUsers
        .filter((u) => u.stats.cityList.some((c) => c.city._id === city))
        .map((u) => ({...u,stats: u.stats.cityList.find((c) => c.city._id === city).profileList}));

    const selectMonthHandler = (stamp) => {
        const thisMonth = months.find((m) => m.timestamp === stamp).timestamp
        localStorage.setItem('userStatsMonth', String(thisMonth));
        setMonth(thisMonth);
    }

    const allProfile = {
        _id: 'null',
        name: 'Все направления',
    };
    const allProfUsers = thisCityUsers.map(u => ({...u, stats: u.stats.reduce((total, cur, i) => {
        let newCur = {...total};
        if (!i) {
            newCur = {
                totalStats: {
                    averageCheque: 0,
                    ordersCount: 0,
                    warrantyCount: 0,
                    turnover: 0,
                },
                isProfileStats: {
                    averageCheque: 0,
                    ordersCount: 0,
                    warrantyCount: 0,
                    turnover: 0,
                },
                profileType: allProfile
            }
        }
        newCur.totalStats.ordersCount += cur.totalStats.ordersCount;
        newCur.isProfileStats.ordersCount += cur.isProfileStats.ordersCount;

        newCur.totalStats.warrantyCount += cur.totalStats.warrantyCount;
        newCur.isProfileStats.warrantyCount += cur.isProfileStats.warrantyCount;

        newCur.totalStats.turnover += cur.totalStats.turnover;
        newCur.isProfileStats.turnover += cur.isProfileStats.turnover;

        newCur.totalStats.averageCheque = Math.round(newCur.totalStats.turnover/newCur.totalStats.ordersCount) || 0;
        newCur.isProfileStats.averageCheque = Math.round(newCur.isProfileStats.turnover/newCur.isProfileStats.ordersCount) || 0;
        return newCur;
    }, {
        totalStats: {
            averageCheque: 0,
            ordersCount: 0,
            warrantyCount: 0,
            turnover: 0,
        },
        isProfileStats: {
            averageCheque: 0,
            ordersCount: 0,
            warrantyCount: 0,
            turnover: 0,
        },
        profileType: allProfile
    })})).map(u => ({...u, stats: [u.stats]}))

    const userInteractAccess = accessor.usersInteract(userInfo);
    if (!userInteractAccess) {
        return <EmptyPage message='Нет доступа к статистике'/>
    }
    return (
        <div className="stats-page">
            <h2>Статистика</h2>
            <div className="stats-page__manager">
                <div>
                    <span>Статистика за</span>
                    <select value={month}
                        onChange={(evt) => selectMonthHandler(+evt.target.value)}>
                        {months.map((m) => (
                            <option className='dark-theme-bg0' key={m.timestamp} value={m.timestamp}>
                                {m.month}
                            </option>
                        ))}
                    </select>
                </div>
                <div>
                    <span>в городе</span>
                    <select
                        value={city}
                        onChange={(evt) =>
                            setCity(userCities.find((c) => c._id === evt.target.value)._id)
                        }>
                        {userCities.map((c) => (
                            <option className='dark-theme-bg0' key={c._id} value={c._id}>
                                {c.name}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="stats-page__body">
                {userProfiles.map(p => <ProfileTables key={p._id} users={thisCityUsers} profileType={p} />)}
                {<ProfileTables users={allProfUsers} profileType={allProfile}/>}
            </div>
        </div>
    );
};
